const place_data_2023=[
  {
    Name: "Hardikkumar chaudhary",
    Roll: "18BEC018",
    Company: "Crest data systems",
    Role: "Site reliability engineer",
    Website: "https://www.crestdatasys.com/",
    Experience:
      "https://drive.google.com/open?id=1lwaLQRcvSCNwgDJijJidDOZOOTx3Zy6V",
    Mail: "hardikchaudhary9750@gmail.com",
    Linkedin: "https://www.linkedin.com/in/hardik-chaudhary-79240a183/",
  },
  {
    Name: "Aakarshak suresh nandwani",
    Roll: "19BEC001",
    Company: "Synopsys",
    Role: "Vlsi digital design / verification ",
    Website: "https://www.synopsys.com/",
    Experience:
      "https://drive.google.com/open?id=16uOaaHSAZGOwqxSz7eyETOWEXyvRB_84",
    Mail: "aakarshak8@gmail.com",
    Linkedin: "https://www.linkedin.com/in/aakarshak-nandwani-877424190/",
  },
 
  {
    Name: "Aditya r",
    Roll: "19BEC004",
    Company: "Cisco",
    Role: "Hardware engineer",
    Website: "https://www.cisco.com/",
    Experience:
      "https://drive.google.com/open?id=1neQ0BAjhW4mVMPBW423lo4bUT_hnwP8g",
    Mail: "radityak2001@gmail.com",
    Linkedin: "https://www.linkedin.com/in/aditya-rk01",
  },
  {
    Name: "Harsh ahuja",
    Roll: "19BEC006",
    Company: "Deloitte india",
    Role: "Audit and assurance",
    Website: "https://www2.deloitte.com/in/en.html",
    Experience:
      "https://drive.google.com/open?id=1SEvH7TzVxkBSc-DDrW_blseG5hURoaMC",
    Mail: "ahujaharsh20@gmail.com",
    Linkedin: "https://www.linkedin.com/in/harsh-ahuja-b32a7a1a0",
  },
  {
    Name: "Avi nawal",
    Roll: "19BEC012",
    Company: "Others",
    Role: "Graduate engineer",
    Website: "https://www.arm.com",
    Experience:
      "https://drive.google.com/open?id=13Hhi1xiFlQS8TT504bDOaE1FRtHdzOQD",
    Mail: "avisnawal@gmail.com",
    Linkedin: "linkedin.com/in/avi-nawal-697290204",
  },
  {
    Name: "Ayush tiwari",
    Roll: "19BEC014",
    Company: "Crest data systems",
    Role: "Software reliability engineer ( sre )",
    Website: "https://www.crestdatasys.com/",
    Experience:
      "https://drive.google.com/open?id=176H9ynjJr6vHufzorqXYguAKkHLbX83b",
    Mail: "ayushhtiwaari@gmail.com",
    Linkedin: "https://www.linkedin.com/in/ayush-tiwari-636853190",
  },
  {
    Name: "Niravkumar kantilal bhanderi",
    Roll: "19BEC016",
    Company: "Synopsys",
    Role: "Vlsi digital design/verification engineer",
    Website: "https://www.synopsys.com/",
    Experience:
      "https://drive.google.com/open?id=1i4I66TTGfO4lVBs-JY-cksV7ZbyBDzR7",
    Mail: "niravbhanderi1972@gmail.com",
    Linkedin: "www.linkedin.com/in/nirav-bhanderi-844164190",
  },
 
  {
    Name: "Chhichhia chaitanya rajesh",
    Roll: "19BEC018",
    Company: "Tcs-digital",
    Role: "Systems engineer",
    Website: "https://www.tcs.com/",
    Experience:
      "https://drive.google.com/open?id=1d2guVy43VqtaejxWtBAHV775LKKCf0oE",
    Mail: "chaitanya27111@gmail.com",
    Linkedin: "https://www.linkedin.com/in/chaitanya-chhichhia-48033a19a/",
  },
  {
    Name: "Debnath barun bablu",
    Roll: "19BEC022",
    Company: "Media.net",
    Role: "Site reliability engineer (sre)",
    Website: "https://www.media.net/",
    Experience:
      "https://drive.google.com/open?id=1N8-ZN-VJE-nAKbFKBqZKEKczDGieQxPg",
    Mail: "barundebnath91@gmail.com",
    Linkedin: "https://linkedin.com/in/barundebnath",
  },
 
  {
    Name: "Dev patwa ",
    Roll: "19BEC024",
    Company: "Searce cosourcing services private limited",
    Role: "Consultancy and sales",
    Website: "https://www.searce.com/",
    Experience:
      "https://drive.google.com/open?id=1NUlyMbb9KkX9OEjMc6c95_HgAQNZh5GJ",
    Mail: "devpatwa.2001@gmail.com",
    Linkedin: "https://www.linkedin.com/in/devpatwa",
  },
  {
    Name: "Dhamecha shivangi m.",
    Roll: "19BEC025",
    Company: "Tata motors",
    Role: "Graduate engineer trainee (get)",
    Website: "https://www.tatamotors.com/",
    Experience:
      "https://drive.google.com/open?id=1bMu7qaWRF10QqzcLfex22z5oxTSvwcxy",
    Mail: "dhamechashivangi0@gmail.com",
    Linkedin: "http://www.linkedin.com/in/shivangi-dhamecha-7965ba218",
  },
  {
    Name: "Dhruvit tripathi",
    Roll: "19BEC027",
    Company: "Crest data systems",
    Role: "Site reliability engineer",
    Website: "https://www.crestdatasys.com/",
    Experience:
      "https://drive.google.com/open?id=1uYUdz1GRWNO3fC3vxsizDKuGVD-o6fwO",
    Mail: "dhruvittripathi@gmail.com",
    Linkedin: "www.linkedin.com/in/dhruvit-tripathi-128338209",
  },
  {
    Name: "Dhvanil chauhan",
    Roll: "19BEC028",
    Company: "Others",
    Role: "Embedded software development",
    Website: "https://drivebuddyai.co/",
    Experience:
      "https://drive.google.com/open?id=15mosexwjRYa0kFDTK_kZlOT-JTLNbHqy",
    Mail: "dhvanilchauhanp@gmail.com",
    Linkedin: "http://www.linkedin.com/in/dhvanil-chauhan-45b473233",
  },
  {
    Name: "Digvijaysinh sandeepsinh chudasama",
    Roll: "19BEC029",
    Company: "Arista networks",
    Role: null,
    Website: "https://www.arista.com/en/",
    Experience:
      "https://drive.google.com/open?id=1VJnZhOvm6-nrrdg8m3V_ynFSQIPQMBP0",
    Mail: "digvijaychudasama27@gmail.com",
    Linkedin: "https://www.linkedin.com/in/digvijaysinh-chudasama27/",
  },
  {
    Name: "Rutul gandhi",
    Roll: "19BEC033",
    Company: "Synopsys",
    Role: "Vlsi digital design/verification",
    Website: "https://www.synopsys.com/",
    Experience:
      "https://drive.google.com/open?id=16FlVhETbrOGEV_APaqdMLLY4zJYgbIJI",
    Mail: "rutulgandhi43@gmail.com",
    Linkedin: "https://www.linkedin.com/in/rutul-gandhi-b309aa191/",
  },
  {
    Name: "Gaurang maheshwari",
    Roll: "19BEC034",
    Company: "Others",
    Role: "Ai/ml engineer",
    Website: "https://www.bosch-softwaretechnologies.com",
    Experience:
      "https://drive.google.com/open?id=1WxCGRh6pH7Z4IJYXkCX0QcRNuu636aAT",
    Mail: "gaurang.ibd@gmail.com",
    Linkedin: "https://www.linkedin.com/in/gaurang-maheshwari-6153881b8/",
  },
  {
    Name: "Anish gupta",
    Roll: "19BEC035",
    Company: 'other',
    Role: "Software development engineer",
    Website: "https://www.omnifynd.com/",
    Experience:
      "https://drive.google.com/open?id=1RMfZkKW27hn62Wn-Ybpx8p9xQorLcejI",
    Mail: "anishgupta2610@gmail.com",
    Linkedin: "https://www.linkedin.com/in/anish-gupta-a28a20191",
  },
  {
    Name: "Shaily nirajbhai hirani",
    Roll: "19BEC038",
    Company: "Zs associates india pvt. ltd.",
    Role: "Btsa ",
    Website: "https://www.zs.com/",
    Experience:
      "https://drive.google.com/open?id=1raP5NzoTe7PzC7LqEMs-7dPAkLgO-Qap",
    Mail: "shailyhirani9@gmail.com ",
    Linkedin: "https://www.linkedin.com/in/shaily-hirani-598768191/",
  },
  {
    Name: "Ishika suresh agarwal",
    Roll: "19BEC041",
    Company: "Only internship offered",
    Role: null,
    Website:
      "https://www.amazon.in/stores/page/A3398561-D71B-4ECB-928E-CBC894B64EEE",
    Experience:
      "https://drive.google.com/open?id=1D34ziXy4WWfD2VKlr7oBzr01o0JKiwif",
    Mail: "ishikaagarwal886@gmail.com",
    Linkedin: "https://www.linkedin.com/in/ishika-agarwal-b7487820b/",
  },
  {
    Name: "Ishika lalit saijwal",
    Roll: "19BEC042",
    Company: "Silion labs",
    Role: "Associate engineer- software design",
    Website: "https://www.silabs.com/",
    Experience:
      "https://drive.google.com/open?id=1J7WoeMvIS71L66LTgVW4ROo56up_XTgl",
    Mail: "ishikasaijwal.nirma@gmail.com",
    Linkedin: "www.linkedin.com/in/ishika-saijwal",
  },
  {
    Name: "Jatin sangai",
    Roll: "19BEC046",
    Company: "Crest data systems",
    Role: "Sre",
    Website: "https://www.crestdatasys.com/",
    Experience:
      "https://drive.google.com/open?id=1tEL5_7aesdfJYCFjO4vYS9JS9DfoTHaw",
    Mail: "jatinsangai14120022@gmail.com",
    Linkedin: "https://www.linkedin.com/in/jatin-sangai-ba38471b2/",
  },
  {
    Name: "Jetwani lalit anil",
    Roll: "19BEC047",
    Company: "Silion labs",
    Role: "Associate engineer - software design",
    Website: "https://www.silabs.com/",
    Experience:
      "https://drive.google.com/open?id=1cUJxv0Iz9x6aeuTmqNw_k9pwHubz3PYu",
    Mail: "lalitjetwani2001@gmail.com",
    Linkedin: "linkedin.com/in/lalit-jetwani",
  },
  {
    Name: "Jugal patel",
    Roll: "19BEC048",
    Company: "Tcs ninja",
    Role: "Assistant system engineer",
    Website: "https://www.tcs.com/",
    Experience:
      "https://drive.google.com/open?id=1Ka13dS99svTrPcxwaadY80n4dVpef3IH",
    Mail: "jugalpatel753@gmail.com",
    Linkedin: "www.linkedin.com/in/jugal-patel-7b61b61b3",
  },
  {
    Name: "Kachhy dhairya jaydeepbhai",
    Roll: "19BEC049",
    Company: "Tcs ninja",
    Role: "Assistant system software engineer",
    Website: "https://www.tcs.com/",
    Experience:
      "https://drive.google.com/open?id=1JUou6f5p0674U-_d2MIY11eV2rH_aVn1",
    Mail: "dhairyakachhy2002@gmail.com",
    Linkedin: "https://www.linkedin.com/in/dhairya-kachhy-709300199/",
  },
  {
    Name: "Kartikey mishra",
    Roll: "19BEC052",
    Company: "Others",
    Role: "Graduate engineer trainee- software",
    Website: "https://addverb.com/",
    Experience:
      "https://drive.google.com/open?id=1hkNa92JhfFtNJaHIF-qIALO9O_5WUEDb",
    Mail: "k.kartikeymishra2017@gmail.com",
    Linkedin: "https://www.linkedin.com/in/kartikey-mishra-66817a194/",
  },
  {
    Name: "Krupa govind lakhani",
    Roll: "19BEC057",
    Company: "Zs associates india pvt. ltd.",
    Role: "Btsa",
    Website: "https://www.zs.com/",
    Experience:
      "https://drive.google.com/open?id=1sDkdmm_ogu9rj_Vv1Hr4EVE557xnlPf5",
    Mail: "lakhanikrupa616@gmail.com",
    Linkedin: "linkedin.com/in/krupa-lakhani-923298206",
  },
  {
    Name: "Nimit malani",
    Roll: "19BEC064",
    Company: "E-infochips",
    Role: "Associate engineer in asic domain",
    Website: "https://www.einfochips.com",
    Experience:
      "https://drive.google.com/open?id=1Z1bEChhsl-Yv6PHWh3kbvl-htmqBCC5B",
    Mail: "malaninimit@gmail.com",
    Linkedin:
      "https://www.linkedin.com/in/nimit-malani-b42888191?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BzSDY3FeGRGSt%2FXPt%2FyuJ7A%3D%3D",
  },
  {
    Name: "Manasi yadav",
    Roll: "19BEC067",
    Company: "Cadence design system",
    Role: "Verification engineer",
    Website: "https://www.cadence.com",
    Experience:
      "https://drive.google.com/open?id=1U96APzLe2s2Zp7LFyvPs0ijq0uS_eo2a",
    Mail: "manasi.yadav829@gmail.com",
    Linkedin: "https://www.linkedin.com/in/manasiyadav/",
  },
  {
    Name: "Darsh maniar",
    Roll: "19BEC069",
    Company: 'other',
    Role: "Analyst",
    Website: "https://home.kpmg/in/en/home.html",
    Experience:
      "https://drive.google.com/open?id=1sgurtvEZUBvVX4P4A3PQjRGxRkzofNGG",
    Mail: "dhmaniar01@gmail.com",
    Linkedin: "https://www.linkedin.com/in/darsh-maniar-368246201/",
  },
  {
    Name: "Manvar shyam",
    Roll: "19BEC071",
    Company: "E-infochips",
    Role: "Asic",
    Website: "https://www.einfochips.com/",
    Experience:
      "https://drive.google.com/open?id=1aont1_Rb5Ui-qAvH4zg17CMpel7n3sBD",
    Mail: "shyammanvar256@gmail.com",
    Linkedin: "www.linkedin.com/in/shyam-manvar-019331218",
  },
  {
    Name: "Mihir rana",
    Roll: "19BEC072",
    Company: "Tcs-digital",
    Role: "Systems engineer",
    Website: "https://www.tcs.com/",
    Experience:
      "https://drive.google.com/open?id=1ddRPpA2r_IS297uO745a5FnQ6FRns7lM",
    Mail: "mihirrana620@gmail.com",
    Linkedin: "https://www.linkedin.com/in/mihir-rana-17909b119/",
  },
  {
    Name: "Mukesh rangwani",
    Roll: "19BEC074",
    Company: "Others",
    Role: "Application developer",
    Website: "https://www.oracle.com/in/index.html",
    Experience:
      "https://drive.google.com/open?id=1bbLaueuySWsYRl9OspMacwQ28TbrIalH",
    Mail: "rangwanimukesh24@gmail.com",
    Linkedin: "https://www.linkedin.com/in/mukesh-rangwani-a5a3341b7/",
  },
  {
    Name: "Himanshu nakrani",
    Roll: "19BEC075",
    Company: "State street corporation",
    Role: "Technical associate",
    Website: "https://www.statestreet.com/home.html",
    Experience:
      "https://drive.google.com/open?id=1glCWF0WXBPUmiYlhE8pFCnuICsLf9i9h",
    Mail: "himanshunakrani0@gmail.com",
    Linkedin: "https://www.linkedin.com/in/himanshu-nakrani",
  },
  {
    Name: "Naman deo",
    Roll: "19BEC076",
    Company: "Zeus learning",
    Role: "Software developer",
    Website: "https://www.zeuslearning.com/",
    Experience:
      "https://drive.google.com/open?id=1oiHqr8cJT2HkncLcb2xNdnpuymp7Yjg7",
    Mail: "naman.deo.nd.149@gmail.com",
    Linkedin: "https://www.linkedin.com/in/namandeo/",
  },
  {
    Name: "Nikhil gupta",
    Roll: "19BEC078",
    Company: "Others",
    Role: "Trainee software engineer",
    Website: "https://www.hsbc.co.in/",
    Experience:
      "https://drive.google.com/open?id=1Myi0iqqpp455964hSm2PBQbgd52QdTlg",
    Mail: "nikhilg2804@gmail.com",
    Linkedin: "www.linkedin.com/in/nikhil-gupta-0172a11a3",
  },
  {
    Name: "Palak jain",
    Roll: "19BEC081",
    Company: "Deloitte india",
    Role: "Sfdc",
    Website: "https://www2.deloitte.com/in/en.html",
    Experience:
      "https://drive.google.com/open?id=1UZ9ZxHnsxY1oAw2zuaYzTEAmn3wmatI9",
    Mail: "palakjain0927@gmail.com",
    Linkedin: "https://www.linkedin.com/public-profile/settings",
  },
  {
    Name: "Pallavi kumari",
    Roll: "19BEC082",
    Company: "Cadence design system",
    Role: 'NA',
    Website: "http://www.cadence.com/",
    Experience:
      "https://drive.google.com/open?id=1WQy1fWJUXl4R-EQUxEtpzD4x-g0A-H5t",
    Mail: "pallaviisharma0609@gmail.com",
    Linkedin: "https://www.linkedin.com/in/pallavi-sharma-22a7351a3",
  },
 
  {
    Name: "Panara harsh ramesh",
    Roll: "19BEC083",
    Company: "Greenvolt",
    Role: "Embedded software",
    Website: "https://www.greenvoltmobility.com/",
    Experience:
      "https://drive.google.com/open?id=1yRW9VknntBLIloOy6LOGuRxtNXtGx7G9",
    Mail: "harshpanara22@gmail.com",
    Linkedin: "https://www.linkedin.com/in/harsh-panara",
  },
  {
    Name: "Panchal aastha sanjay",
    Roll: "19BEC084",
    Company: "Others",
    Role: "Graduate engineer",
    Website: "https://www.arm.com/",
    Experience:
      "https://drive.google.com/open?id=1kGe1veoGGuD-ZmLqVZEVFjMIapZjPIqU",
    Mail: "panchalaastha@gmail.com",
    Linkedin: "linkedin.com/in/aastha-panchal-259017235",
  },
  {
    Name: "Panchal aastha sanjay",
    Roll: "19BEC084",
    Company: "Tcs ninja",
    Role: "Assistant system engineer - trainee",
    Website: "https://www.tcs.com/",
    Experience:
      "https://drive.google.com/open?id=1bdJAysNLwj7ahZ2EK-QD9rU6iKCqPrbX",
    Mail: "panchalaastha@gmail.com",
    Linkedin: "linkedin.com/in/aastha-panchal-259017235",
  },
  {
    Name: "Divyam pandya",
    Roll: "19BEC085",
    Company: "Synopsys",
    Role: "Vlsi digital design/verification engineer",
    Website: "https://www.synopsys.com/",
    Experience:
      "https://drive.google.com/open?id=1Mf7fRcYYQ-hSGL41IhKbH3KDy1C33R2Z",
    Mail: "divyampandya26@gmail.com",
    Linkedin: "linkedin.com/in/divyam-pandya-351681223",
  },
  {
    Name: "Tanmay kamalbhai parekh",
    Roll: "19BEC086",
    Company: "Euler motors",
    Role: "Embedded engineer (hardware)",
    Website: "https://www.eulermotors.com/",
    Experience:
      "https://drive.google.com/open?id=1zWoVBE0Fttyq0Iuxr26HBgb06U_7EHNf",
    Mail: "tanmayparekh20@gmail.com",
    Linkedin: "linkedin.com/in/tanmay-parekh-0306",
  },
  {
    Name: "Aakash parmar",
    Roll: "19BEC087",
    Company: "Others",
    Role: "Embedded hardware",
    Website: "https://www.monarch-innovation.com/",
    Experience:
      "https://drive.google.com/open?id=1yqp0N_sogquKpuMyCrXTbDvUOEQS3QVr",
    Mail: "parmaraakash2353@gmail.com",
    Linkedin: "https://www.linkedin.com/in/parmar-aakash-102a75192/",
  },
  {
    Name: "Yuvrajsinh lalsinh parmar",
    Roll: "19BEC090",
    Company: "Crest data systems",
    Role: "Sre - site reliability engineer",
    Website: "https://www.crestdatasys.com/",
    Experience:
      "https://drive.google.com/open?id=19PzvspzWK7UcJc4hOcqGMDaWxxGBHHMA",
    Mail: "yuvrajsinhthakor100@gmail.com",
    Linkedin: "https://www.linkedin.com/in/yuvrajsinh-parmar/",
  },
  
  {
    Name: "Patel het sunilkumar ",
    Roll: "19BEC093",
    Company: "E-infochips",
    Role: "Associate engineer in product engineering services (pes)",
    Website: " www.einfochips.com      ",
    Experience:
      "https://drive.google.com/open?id=1lSGvWJLn9d-2kE4Byed-Mv-bPHz6E3YB",
    Mail: "het4902@gmail.com",
    Linkedin: "https://www.linkedin.com/in/het-patel-530653200/",
  },
  {
    Name: "Hetvi patel",
    Roll: "19BEC094",
    Company: "ARM",
    Role: "Get",
    Website: "/",
    Experience:
      "https://drive.google.com/open?id=1vAf4islbPytnLK3SN0IE42BWiCXYQ1O7",
    Mail: "hetviapatel2142@gmail.com",
    Linkedin: "www.linkedin.com/in/hetvi-patel-6b0858207",
  },
  
  {
    Name: "Parikshit rashmikant patel",
    Roll: "19BEC097",
    Company: "E-infochips",
    Role: "Associate engineer",
    Website: "www.einfochips.com",
    Experience:
      "https://drive.google.com/open?id=1D80GZihJRxoM9n-nMJDf_p2YF7PPtTP9",
    Mail: "patel1610parikshit3041@gmail.com",
    Linkedin: "https://www.linkedin.com/in/parikshit-patel-41b6551a4/",
  },
  {
    Name: "Patel sneh dushyantkumar",
    Roll: "19BEC099",
    Company: "E-infochips",
    Role: "Associated engineer",
    Website: "https://www.einfochips.com/",
    Experience:
      "https://drive.google.com/open?id=10HE8lqf62GbNr2kUSDU5caXEZXsyY1mP",
    Mail: "snehpatel7801@gmail.com",
    Linkedin: "https://www.linkedin.com/in/sneh-patel-0951a3208",
  },
  {
    Name: "Patel vraj bhaveshkumar",
    Roll: "19BEC100",
    Company: "Synopsys",
    Role: "Vlsi digital design/verification engineer",
    Website:
      "https://www.synopsys.com/company/contact-synopsys/office-locations/india/about-synopsys-india.html",
    Experience:
      "https://drive.google.com/open?id=1HFnWv_Un9JDnd6Q8qhyiULO6E1TEYnkq",
    Mail: "vraj14082001@gmail.com",
    Linkedin: "https://www.linkedin.com/in/vrajpatel001/",
  },
  {
    Name: "Pranjal singh ",
    Roll: "19BEC101",
    Company: "Searce cosourcing services private limited",
    Role: "Data engineer ",
    Website: "https://www.searce.com/",
    Experience:
      "https://drive.google.com/open?id=1_Gp6CI08XWQP-lWPPydgxUpGEVO679as",
    Mail: "pranjals350@gmail.com",
    Linkedin: "linkedin.com/in/pranjal-singh-59150a1b6",
  },
  {
    Name: "Rai maheevatsa",
    Roll: "19BEC103",
    Company: "Others",
    Role: "Graduate analyst",
    Website: "www.db.com",
    Experience:
      "https://drive.google.com/open?id=1qjKahGa1GS0Knx8xW1il6X759Yn2w-hz",
    Mail: "raimaheevatsa@gmail.com",
    Linkedin: "www.linkedin.com/in/maheevatsa-rai",
  },
  {
    Name: "Jainil raval",
    Roll: "19BEC108",
    Company: "Others",
    Role: "Software engineer",
    Website: "www.hsbc.com",
    Experience:
      "https://drive.google.com/open?id=16bl7U0DpWdoi2wfivCIT3t6XWt9iTwwq",
    Mail: "jainilraval02@gmail.com",
    Linkedin: "https://www.linkedin.com/in/jainil-raval/",
  },
  {
    Name: "Rishita chaliawala ",
    Roll: "19BEC113",
    Company: "Deloitte india",
    Role: "Audit & assurance",
    Website: "https://www2.deloitte.com/us/en.html",
    Experience:
      "https://drive.google.com/open?id=1ISxZvYeNNEy3dyeSsdJfhIh743ReNKNx",
    Mail: "rishita.802.chaliawala@gmail.com",
    Linkedin: "https://www.linkedin.com/in/rishitachaliawala",
  },
  {
    Name: "Rythem mehta",
    Roll: "19BEC114",
    Company: "Others",
    Role: "Analyst",
    Website: "https://home.kpmg/in/en/home.html",
    Experience:
      "https://drive.google.com/open?id=1AsfohQw7rgGLKJa3vJjqaMOgiyUzK7sh",
    Mail: "rythemmehtaa@gmail.com",
    Linkedin: "https://www.linkedin.com/in/rythem-mehta-7457111a7/",
  },
  {
    Name: "Shah abhay",
    Roll: "19BEC119",
    Company: "Cactus communications",
    Role: "Only internship",
    Website: "https://cactusglobal.com/",
    Experience:
      "https://drive.google.com/open?id=1GwgVUCXJLb4ReYA946-UbHXpQEVKKI44",
    Mail: "abhayshah00007@gmail.com",
    Linkedin: "https://www.linkedin.com/in/abhay-shah07/",
  },
 
  {
    Name: "Khush shah",
    Roll: "19BEC120",
    Company: "Crest data systems",
    Role: "Site reliability engineer",
    Website: "https://www.crestdatasys.com/",
    Experience:
      "https://drive.google.com/open?id=1RYIVWV8uDlCU9OJB7XDi0AINqpWGXdh6",
    Mail: "khushshahj@gmail.com",
    Linkedin: "https://www.linkedin.com/in/shah-khush-903b80205/",
  },
  {
    Name: "Shivaditya chhaparwal",
    Roll: "19BEC124",
    Company: "Mussikar",
    Role: "Software development engineer",
    Website: "https://musikaar.com/",
    Experience:
      "https://drive.google.com/open?id=18nogT1P0D-AjlZvwfTLuJXxes4gmZEEU",
    Mail: "chhaparwalshivaditya@gmail.com",
    Linkedin: "https://www.linkedin.com/in/shivadityachhaparwal/",
  },
  {
    Name: "Sukhadia dhwanil jatinkumar",
    Roll: "19BEC128",
    Company: "Synopsys",
    Role: "Analog design engineer",
    Website: "https://www.synopsys.com/",
    Experience:
      "https://drive.google.com/open?id=1mTOcGxuQvXRe41WvV5gi7K9RUhTc5Pwh",
    Mail: "dhwanilsukhadia12@gmail.com",
    Linkedin: "https://www.linkedin.com/in/dhwanil-sukhadia/",
  },
  
  {
    Name: "Taneesha chaudhary",
    Roll: "19BEC131",
    Company: "Deloitte india",
    Role: "Salesforce role as analyst",
    Website: "https://www2.deloitte.com/in/en.html",
    Experience:
      "https://drive.google.com/open?id=1C3N23Wrr5r6FT5I_Nn9pVIezV28-AL6b",
    Mail: "taneesha1234@gmail.com",
    Linkedin: "www.linkedin.com/in/taneeshachaudhary",
  },
  {
    Name: "Tanisha mittal",
    Roll: "19BEC132",
    Company: "Arista networks",
    Role: "Software test engineer",
    Website: "https://www.arista.com/en/",
    Experience:
      "https://drive.google.com/open?id=1600uyHNN9O0OnePqqiL5lUYzwGzB3gSl",
    Mail: "MTANISHA1431@GMAIL.COM",
    Linkedin: "https://www.linkedin.com/in/tanisha-mittal-1a5a261b4/",
  },
  {
    Name: "Tejas deshpande",
    Roll: "19BEC133",
    Company: "Oracle-gbu",
    Role: "Applications developer",
    Website: "https://www.oracle.com/",
    Experience:
      "https://drive.google.com/open?id=1H95HdfJL7ZKlQ3zErTnF6SfFwdYmaYpq",
    Mail: "deshpandetejas08@gmail.com",
    Linkedin: "https://www.linkedin.com/in/tejas-deshpande-910b18217/",
  },
  
  {
    Name: "Kanak tekwani",
    Roll: "19BEC134",
    Company: "State street corporation",
    Role: "Ml engineer",
    Website: "https://www.statestreet.com/home.html",
    Experience:
      "https://drive.google.com/open?id=14Ptk5ToSBxS62w5yQQXslrepTbh1sTEB",
    Mail: "kanaktekwani@gmail.com",
    Linkedin: "https://www.linkedin.com/in/kanak-tekwani",
  },
  {
    Name: "Meet thakar",
    Roll: "19BEC135",
    Company: "Infineon",
    Role: "Application engineer",
    Website: "https://www.infineon.com/cms/en/",
    Experience:
      "https://drive.google.com/open?id=1iTfEIut_06-gbZpOoHVm5cKvj2mFaCeH",
    Mail: "meetthakar02@gmail.com",
    Linkedin: "https://www.linkedin.com/in/meet-thakar-643605220",
  },
  {
    Name: "Thakkar krishna chandrakant",
    Roll: "19BEC136",
    Company: "Synopsys",
    Role: "Vlsi digital design/verification engineer",
    Website: "https://www.synopsys.com/",
    Experience:
      "https://drive.google.com/open?id=1Zox2gu3jAXSd_AehiwpR_C6N7Y53dnhD",
    Mail: "kthakkar.1007@gmail.com",
    Linkedin: "https://www.linkedin.com/in/krishna-thakkar-3899061ab/",
  },
 
  
  {
    Name: "Yash thakkar",
    Roll: "19BEC137",
    Company: "E-infochips",
    Role: "Associate engineer ",
    Website: "www.einfochips.com",
    Experience:
      "https://drive.google.com/open?id=1_VVso6MinjFvM2HmOEesbtGUcUgANjqo",
    Mail: "yashthakkar12342@gmail.com",
    Linkedin: "https://www.linkedin.com/in/yash-thakkar-ab97731ab",
  },
  
  {
    Name: "Utsav raj goyal",
    Roll: "19BEC141",
    Company: "off-campus",
    Role: 'NA',
    Website: "https://www.isro.gov.in/",
    Experience:
      "https://drive.google.com/open?id=1ypj_avgErLpIumegZc3xZhFeMZhNOBw-",
    Mail: "utsavrajgoyal40@gmail.com",
    Linkedin: '/',
  },
  {
    Name: "Vanshika gupta",
    Roll: "19BEC143",
    Company: "Synopsys",
    Role: "Vlsi digital design/verification engineers",
    Website: "https://www.synopsys.com/",
    Experience:
      "https://drive.google.com/open?id=1hVYR5mK0SgO9h-fTHHDcUCgAnXCoVhrl",
    Mail: "guptavanshika0011@gmail.con",
    Linkedin: "linkedin.com/in/vanshika-gupta-2b7ab7209",
  },
  {
    Name: "Yash gandhi",
    Roll: "19BEC146",
    Company: "Crest data systems",
    Role: "Site reliability engineer ",
    Website: "https://www.crestdatasys.com/",
    Experience:
      "https://drive.google.com/open?id=1bAfYNOLDxb1g-oPnBXXLmx4Xm6MqYs7J",
    Mail: "gandhiyash4939@gmail.com",
    Linkedin: "https://www.linkedin.com/in/yash-gandhi-417b25186",
  },
  {
    Name: "Yashasvi patel",
    Roll: "19BEC148",
    Company: "Others",
    Role: "Software development engineer",
    Website: "https://www.northerntrust.com/asia-pac/home",
    Experience:
      "https://drive.google.com/open?id=1R86Unn_34sj_x1JZ0pp7QveKw-N1MYcX",
    Mail: "yashasvi2622@gmail.com",
    Linkedin: "https://www.linkedin.com/in/yashasvi-patel-7169aa1b4/",
  },
  
  {
    Name: "Abhishek zinzuvadiya",
    Roll: "19BEC149",
    Company: "Cadence design system",
    Role: "Verification ip using c/c++",
    Website: "https://www.cadence.com/",
    Experience:
      "https://drive.google.com/open?id=1qDr_dtvWkF3q_FeP5XCfA-Xac1O7ZeBD",
    Mail: "avsoni6901@gmail.com",
    Linkedin: "https://www.linkedin.com/in/abhishek-zinzuvadiya/",
  },
  {
    Name: "Nisarg vyas ",
    Roll: "20BEC505",
    Company: "E-infochips",
    Role: "Associate engineer ",
    Website: "https://www.einfochips.com",
    Experience:
      "https://drive.google.com/open?id=17JbnuCF4xIQeJv1GCXAnMeNvYENKxIJB",
    Mail: "nisargdvyas@gmail.com",
    Linkedin: "https://www.linkedin.com/in/nisarg-vyas-1369a0237/",
  },
  {
    Name: "Safvan i mansuri",
    Roll: "20BEC508",
    Company: "Crest data systems",
    Role: "Site reliability engineer",
    Website: "https://www.crestdatasys.com/",
    Experience:
      "https://drive.google.com/open?id=1SXDdRyyIII6Dp51W-VY_qve5M78H5ySY",
    Mail: "safvanmansuri77@gmail.com",
    Linkedin: "https://www.linkedin.com/in/safvan-mansuri-815a83184/",
  },
  {
    Name: "Sanghani yashkumar anilbhai ",
    Roll: "20BEC509",
    Company: 'other',
    Role: "Embedded engineer ",
    Website: "https://www.greenvoltmobility.com/",
    Experience:
      "https://drive.google.com/open?id=1sQIoDOfVFj3WGZ270PAqPpbyijC_E8fb",
    Mail: "yaspatel7016@gmail.com",
    Linkedin: "https://www.linkedin.com/in/yash-sanghani-3b1b60220",
  },
];


export default place_data_2023;